import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import { DigiQuoteSettings, RequoteSettings } from './types';

export type UseUpdateRequoteSettingsParams = {
  groupId: string;
};

export const getUpdateRequoteSettingsKey = (
  params: UseUpdateRequoteSettingsParams,
) => ['suppliers', params.groupId, 'updateRequoteSettings'] as const;

export const useUpdateRequoteSettings: MutationFunction<
  DigiQuoteSettings,
  RequoteSettings,
  [UseUpdateRequoteSettingsParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { groupId } = params;

  const mutationKey = getUpdateRequoteSettingsKey(params);
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request(`/suppliers/${groupId}/digi_quote_settings`, {
        init: {
          method: 'PATCH',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey,
  });
};
